import React from 'react';
import FilterActions from '../../actions/FilterActionCreator';
import SelectEntityFactory from '../Common/SelectEntityFactory';

export default SelectEntityFactory(FilterActions.search);
